import script from "./SidebarCombos.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarCombos.vue?vue&type=script&setup=true&lang=js"

import "./SidebarCombos.vue?vue&type=style&index=0&id=6b3ceb57&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3ceb57"]])

export default __exports__